import {EntityService} from '../../../service/EntityService';

export class ValueReplacesService extends EntityService {

  static entity = 'app/value-replaces';

}
